// QuestionRoutes.js (or put it next to where the dropdown lives)
export const QUESTION_TYPE_TO_ROUTE = {
    'MCQ': '/admin/mcq-content',
    'Dropdown': '/admin/dropdown-content',
    'Drag Drop': '/admin/dragdrop-content',
    'Multiple Radio': '/admin/multiradio-content',
    'Sorting': '/admin/sort-content',
    'Sentence Highlight': '/admin/sentence-content',
    'Fill in the Blanks': '/admin/fill-content',
    'Table Dropdown': '/admin/table-dropDown',
    'Multidropdown': '/admin/multiDropDown',
    'Table Highlight': '/admin/table-Highlight'
};
